module.exports = __webpack_public_path__ + "static/img/gws logo.1c183ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gws logo.png
// module id = VWkD
// module chunks = 1